var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorGeneral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "120px",
    viewBox: "0 0 119 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/error 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/error-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.4207, 4.4207)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.980338,24.9803375 C109.180338,35.9803375 112.580338,49.5803375 110.580338,63.5803375 C106.180338,93.9803375 77.8803375,114.980338 47.5803375,110.580338 C17.2803375,106.180338 -3.81966246,77.8803375 0.580337544,47.5803375 C4.98033754,17.2803375 33.2803375,-3.81966246 63.5803375,0.580337544 C74.0803375,2.08033754 83.3803375,6.38033754 90.9803375,12.6803375",
    id: "Path_00000107572939440084201380000010529341474164665272_",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.5803, 35.5803)",
    id: "Path",
    stroke: "#FF7900"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 0,
    x2: 0,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 0,
    y2: 0
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGeneral);
export default __webpack_public_path__ + "static/media/error_general.a70cee5bec5171757c6ee4a79cd2b9c7.svg";
export { ForwardRef as ReactComponent };